<template>
    <div class="container page" style="background: linear-gradient(45deg, rgb(172, 98, 204), rgb(172, 98, 204));">
        <van-nav-bar title="用户分享" class="nav-bar">
            <template #left>
                <van-icon name="arrow-left" color="#333" @click="back()" />
            </template>
        </van-nav-bar>
        <div class="wrapper" style="overflow: auto;">
            <div id="vux_view_box_body" class="weui-tab__panel vux-fix-safari-overflow-scrolling">
                <div class="discuss-bg">
                    <div class="discuss-content-size">
                        <div class="discuss-content"><img src="/img/discuss/1.a30c8df.png" alt="" class="a1"> <img
                                src="/img/discuss/2.4424ce6.png" alt="" class="a2">
                            <img src="/img/discuss/3.11209dc.png" alt="" class="a3">
                            <div class="discuss-title">
                                <p style="background: linear-gradient(45deg, rgb(172, 98, 204), rgb(172, 98, 204));">
                                    来自VFmZWxeJ1G的分享</p>
                            </div>
                            <div class="discuss-imgshowfx">
                                <div class="discuss-imgshow"><img src="/img/discuss/1.5f21463.jpg" @click="previewImg('/img/discuss/1.5f21463.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/2.4cfd9a2.jpg" @click="previewImg('/img/discuss/2.4cfd9a2.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/3.ac50f72.jpg" @click="previewImg('/img/discuss/3.ac50f72.jpg')" alt="" class="zoomable">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="discuss-content-size">
                        <div class="discuss-content"><img src="/img/discuss/1.a30c8df.png" alt="" class="a1"> <img
                                src="/img/discuss/2.4424ce6.png" alt="" class="a2">
                            <img src="/img/discuss/3.11209dc.png" alt="" class="a3">
                            <div class="discuss-title">
                                <p style="background: linear-gradient(45deg, rgb(172, 98, 204), rgb(172, 98, 204));">
                                    来自Xbh321M3GM的分享</p>
                            </div>
                            <div class="discuss-imgshowfx">
                                <div class="discuss-imgshow"><img src="/img/discuss/1.b53709c.jpg" @click="previewImg('/img/discuss/1.b53709c.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/2.404eeb8.jpg" @click="previewImg('/img/discuss/2.404eeb8.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/3.0ef30bc.jpg" @click="previewImg('/img/discuss/3.0ef30bc.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/4.94cbfeb.jpg" @click="previewImg('/img/discuss/4.94cbfeb.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/5.2160978.jpg" @click="previewImg('/img/discuss/5.2160978.jpg')" alt="" class="zoomable">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="discuss-content-size">
                        <div class="discuss-content"><img src="/img/discuss/1.a30c8df.png" alt="" class="a1"> <img
                                src="/img/discuss/2.4424ce6.png" alt="" class="a2">
                            <img src="/img/discuss/3.11209dc.png" alt="" class="a3">
                            <div class="discuss-title">
                                <p style="background: linear-gradient(45deg, rgb(172, 98, 204), rgb(172, 98, 204));">
                                    来自pAM835GEP1的分享</p>
                            </div>
                            <div class="discuss-imgshowfx">
                                <div class="discuss-imgshow"><img src="/img/discuss/1.50981f5.jpg" @click="previewImg('/img/discuss/1.50981f5.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/2.75f4ae4.jpg" @click="previewImg('/img/discuss/2.75f4ae4.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/3.6ab5681.jpg" @click="previewImg('/img/discuss/3.6ab5681.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/4.e55845c.jpg" @click="previewImg('/img/discuss/4.e55845c.jpg')" alt="" class="zoomable">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="discuss-content-size">
                        <div class="discuss-content"><img src="/img/discuss/1.a30c8df.png" alt="" class="a1"> <img
                                src="/img/discuss/2.4424ce6.png" alt="" class="a2">
                            <img src="/img/discuss/3.11209dc.png" alt="" class="a3">
                            <div class="discuss-title">
                                <p style="background: linear-gradient(45deg, rgb(172, 98, 204), rgb(172, 98, 204));">
                                    来自WcqqXtXky3的分享</p>
                            </div>
                            <div class="discuss-imgshowfx">
                                <div class="discuss-imgshow"><img src="/img/discuss/1.8a58f6c.jpg" @click="previewImg('/img/discuss/1.8a58f6c.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/2.2ae6530.jpg" @click="previewImg('/img/discuss/2.2ae6530.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/3.1893b98.jpg" @click="previewImg('/img/discuss/3.1893b98.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/4.c4a4955.jpg" @click="previewImg('/img/discuss/4.c4a4955.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/5.d91d93f.jpg" @click="previewImg('/img/discuss/5.d91d93f.jpg')" alt="" class="zoomable">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="discuss-content-size">
                        <div class="discuss-content"><img src="/img/discuss/1.a30c8df.png" alt="" class="a1"> <img
                                src="/img/discuss/2.4424ce6.png" alt="" class="a2">
                            <img src="/img/discuss/3.11209dc.png" alt="" class="a3">
                            <div class="discuss-title">
                                <p style="background: linear-gradient(45deg, rgb(172, 98, 204), rgb(172, 98, 204));">
                                    来自GuvdRuzuTs的分享</p>
                            </div>
                            <div class="discuss-imgshowfx">
                                <div class="discuss-imgshow"><img src="/img/discuss/1.a5906cf.jpg" @click="previewImg('/img/discuss/1.a5906cf.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/2.3eccb0e.jpg" @click="previewImg('/img/discuss/2.3eccb0e.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/3.ff6ed4b.jpg" @click="previewImg('/img/discuss/3.ff6ed4b.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/4.437912d.jpg" @click="previewImg('/img/discuss/4.437912d.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/5.5e8cd87.jpg" @click="previewImg('/img/discuss/5.5e8cd87.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/6.6881dda.jpg" @click="previewImg('/img/discuss/6.6881dda.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/7.8e1588b.jpg" @click="previewImg('/img/discuss/7.8e1588b.jpg')" alt="" class="zoomable">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="discuss-content-size">
                        <div class="discuss-content"><img src="/img/discuss/1.a30c8df.png" alt="" class="a1"> <img
                                src="/img/discuss/2.4424ce6.png" alt="" class="a2">
                            <img src="/img/discuss/3.11209dc.png" alt="" class="a3">
                            <div class="discuss-title">
                                <p style="background: linear-gradient(45deg, rgb(172, 98, 204), rgb(172, 98, 204));">
                                    来自a4KMBMkrRm的分享</p>
                            </div>
                            <div class="discuss-imgshowfx">
                                <div class="discuss-imgshow"><img src="/img/discuss/1.a5a9e65.jpg" @click="previewImg('/img/discuss/1.a5a9e65.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/2.4a958e3.jpg" @click="previewImg('/img/discuss/2.4a958e3.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/3.e39ae34.jpg" @click="previewImg('/img/discuss/3.e39ae34.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/4.b416693.jpg" @click="previewImg('/img/discuss/4.b416693.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/5.dedb211.jpg" @click="previewImg('/img/discuss/5.dedb211.jpg')" alt="" class="zoomable">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="discuss-content-size">
                        <div class="discuss-content"><img src="/img/discuss/1.a30c8df.png" alt="" class="a1"> <img
                                src="/img/discuss/2.4424ce6.png" alt="" class="a2">
                            <img src="/img/discuss/3.11209dc.png" alt="" class="a3">
                            <div class="discuss-title">
                                <p style="background: linear-gradient(45deg, rgb(172, 98, 204), rgb(172, 98, 204));">
                                    来自tEhCHu8NXy的分享</p>
                            </div>
                            <div class="discuss-imgshowfx">
                                <div class="discuss-imgshow"><img src="/img/discuss/1.5b5ca28.jpg" @click="previewImg('/img/discuss/1.5b5ca28.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/2.bb560d9.jpg" @click="previewImg('/img/discuss/2.bb560d9.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/3.746504f.jpg" @click="previewImg('/img/discuss/3.746504f.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/4.d68471d.jpg" @click="previewImg('/img/discuss/4.d68471d.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/5.a1fc9f4.jpg" @click="previewImg('/img/discuss/5.a1fc9f4.jpg')" alt="" class="zoomable">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="discuss-content-size">
                        <div class="discuss-content"><img src="/img/discuss/1.a30c8df.png" alt="" class="a1"> <img
                                src="/img/discuss/2.4424ce6.png" alt="" class="a2">
                            <img src="/img/discuss/3.11209dc.png" alt="" class="a3">
                            <div class="discuss-title">
                                <p style="background: linear-gradient(45deg, rgb(172, 98, 204), rgb(172, 98, 204));">
                                    来自PBR88rnaBw的分享</p>
                            </div>
                            <div class="discuss-imgshowfx">
                                <div class="discuss-imgshow"><img src="/img/discuss/1.0aa2fd7.jpg" @click="previewImg('/img/discuss/1.0aa2fd7.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/2.b388737.jpg" @click="previewImg('/img/discuss/2.b388737.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/3.18904a1.jpg" @click="previewImg('/img/discuss/3.18904a1.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/4.755ddad.jpg" @click="previewImg('/img/discuss/4.755ddad.jpg')" alt="" class="zoomable">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="discuss-content-size">
                        <div class="discuss-content"><img src="/img/discuss/1.a30c8df.png" alt="" class="a1"> <img
                                src="/img/discuss/2.4424ce6.png" alt="" class="a2">
                            <img src="/img/discuss/3.11209dc.png" alt="" class="a3">
                            <div class="discuss-title">
                                <p style="background: linear-gradient(45deg, rgb(172, 98, 204), rgb(172, 98, 204));">
                                    来自PEWbvYfSQu的分享</p>
                            </div>
                            <div class="discuss-imgshowfx">
                                <div class="discuss-imgshow"><img src="/img/discuss/1.77200f4.jpg" @click="previewImg('/img/discuss/1.77200f4.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/2.b3e9d28.jpg" @click="previewImg('/img/discuss/2.b3e9d28.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/3.90072f3.jpg" @click="previewImg('/img/discuss/3.90072f3.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/4.6b0e9d8.jpg" @click="previewImg('/img/discuss/4.6b0e9d8.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/5.de8f3b5.jpg" @click="previewImg('/img/discuss/5.de8f3b5.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/6.164d46b.jpg" @click="previewImg('/img/discuss/6.164d46b.jpg')" alt="" class="zoomable">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="discuss-content-size">
                        <div class="discuss-content"><img src="/img/discuss/1.a30c8df.png" alt="" class="a1"> <img
                                src="/img/discuss/2.4424ce6.png" alt="" class="a2">
                            <img src="/img/discuss/3.11209dc.png" alt="" class="a3">
                            <div class="discuss-title">
                                <p style="background: linear-gradient(45deg, rgb(172, 98, 204), rgb(172, 98, 204));">
                                    来自zrWZRS6kc1的分享</p>
                            </div>
                            <div class="discuss-imgshowfx">
                                <div class="discuss-imgshow"><img src="/img/discuss/1.ab44fcd.jpg" @click="previewImg('/img/discuss/1.ab44fcd.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/2.9e9e603.jpg" @click="previewImg('/img/discuss/2.9e9e603.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/3.495ea02.jpg" @click="previewImg('/img/discuss/3.495ea02.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/4.b715865.jpg" @click="previewImg('/img/discuss/4.b715865.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/5.e0d0887.jpg" @click="previewImg('/img/discuss/5.e0d0887.jpg')" alt="" class="zoomable">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="discuss-content-size">
                        <div class="discuss-content"><img src="/img/discuss/1.a30c8df.png" alt="" class="a1"> <img
                                src="/img/discuss/2.4424ce6.png" alt="" class="a2">
                            <img src="/img/discuss/3.11209dc.png" alt="" class="a3">
                            <div class="discuss-title">
                                <p style="background: linear-gradient(45deg, rgb(172, 98, 204), rgb(172, 98, 204));">
                                    来自bPFwzFpdGS的分享</p>
                            </div>
                            <div class="discuss-imgshowfx">
                                <div class="discuss-imgshow"><img src="/img/discuss/1.56bcaa3.jpg" @click="previewImg('/img/discuss/1.56bcaa3.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/2.ea0450b.jpg" @click="previewImg('/img/discuss/2.ea0450b.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/3.4b2a4ed.jpg" @click="previewImg('/img/discuss/3.4b2a4ed.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/4.ed91d76.jpg" @click="previewImg('/img/discuss/4.ed91d76.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/5.fdcf31b.jpg" @click="previewImg('/img/discuss/5.fdcf31b.jpg')" alt="" class="zoomable">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="discuss-content-size">
                        <div class="discuss-content"><img src="/img/discuss/1.a30c8df.png" alt="" class="a1"> <img
                                src="/img/discuss/2.4424ce6.png" alt="" class="a2">
                            <img src="/img/discuss/3.11209dc.png" alt="" class="a3">
                            <div class="discuss-title">
                                <p style="background: linear-gradient(45deg, rgb(172, 98, 204), rgb(172, 98, 204));">
                                    来自mQ5QYbumYk的分享</p>
                            </div>
                            <div class="discuss-imgshowfx">
                                <div class="discuss-imgshow"><img src="/img/discuss/1.51059fe.jpg" @click="previewImg('/img/discuss/1.51059fe.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/2.fecda3d.jpg" @click="previewImg('/img/discuss/2.fecda3d.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/3.970d4c9.jpg" @click="previewImg('/img/discuss/3.970d4c9.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/4.d7d415f.jpg" @click="previewImg('/img/discuss/4.d7d415f.jpg')" alt="" class="zoomable">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="discuss-content-size">
                        <div class="discuss-content"><img src="/img/discuss/1.a30c8df.png" alt="" class="a1"> <img
                                src="/img/discuss/2.4424ce6.png" alt="" class="a2">
                            <img src="/img/discuss/3.11209dc.png" alt="" class="a3">
                            <div class="discuss-title">
                                <p style="background: linear-gradient(45deg, rgb(172, 98, 204), rgb(172, 98, 204));">
                                    来自QxbCNj6XGt的分享</p>
                            </div>
                            <div class="discuss-imgshowfx">
                                <div class="discuss-imgshow"><img src="/img/discuss/1.e86d83b.jpg" @click="previewImg('/img/discuss/1.e86d83b.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/2.0fb5db7.jpg" @click="previewImg('/img/discuss/2.0fb5db7.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/3.73dd3d5.jpg" @click="previewImg('/img/discuss/3.73dd3d5.jpg')" alt="" class="zoomable">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="discuss-content-size">
                        <div class="discuss-content"><img src="/img/discuss/1.a30c8df.png" alt="" class="a1"> <img
                                src="/img/discuss/2.4424ce6.png" alt="" class="a2">
                            <img src="/img/discuss/3.11209dc.png" alt="" class="a3">
                            <div class="discuss-title">
                                <p style="background: linear-gradient(45deg, rgb(172, 98, 204), rgb(172, 98, 204));">
                                    来自FQ7AWPhunu的分享</p>
                            </div>
                            <div class="discuss-imgshowfx">
                                <div class="discuss-imgshow"><img src="/img/discuss/1.d175164.jpg" @click="previewImg('/img/discuss/1.d175164.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/2.83fc6f1.jpg" @click="previewImg('/img/discuss/2.83fc6f1.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/3.0371d7f.jpg" @click="previewImg('/img/discuss/3.0371d7f.jpg')" alt="" class="zoomable">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="discuss-content-size">
                        <div class="discuss-content"><img src="/img/discuss/1.a30c8df.png" alt="" class="a1"> <img
                                src="/img/discuss/2.4424ce6.png" alt="" class="a2">
                            <img src="/img/discuss/3.11209dc.png" alt="" class="a3">
                            <div class="discuss-title">
                                <p style="background: linear-gradient(45deg, rgb(172, 98, 204), rgb(172, 98, 204));">
                                    来自fPmdgg4VuU的分享</p>
                            </div>
                            <div class="discuss-imgshowfx">
                                <div class="discuss-imgshow"><img src="/img/discuss/1.2685b51.jpg" @click="previewImg('/img/discuss/1.2685b51.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/2.2d33ed7.jpg" @click="previewImg('/img/discuss/2.2d33ed7.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/3.b64a1bb.jpg" @click="previewImg('/img/discuss/3.b64a1bb.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/4.cb4eadd.jpg" @click="previewImg('/img/discuss/4.cb4eadd.jpg')" alt="" class="zoomable">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="discuss-content-size">
                        <div class="discuss-content"><img src="/img/discuss/1.a30c8df.png" alt="" class="a1"> <img
                                src="/img/discuss/2.4424ce6.png" alt="" class="a2">
                            <img src="/img/discuss/3.11209dc.png" alt="" class="a3">
                            <div class="discuss-title">
                                <p style="background: linear-gradient(45deg, rgb(172, 98, 204), rgb(172, 98, 204));">
                                    来自cWFFQYE33Y的分享</p>
                            </div>
                            <div class="discuss-imgshowfx">
                                <div class="discuss-imgshow"><img src="/img/discuss/1.ecb1abb.jpg" @click="previewImg('/img/discuss/1.ecb1abb.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/2.ad222e0.jpg" @click="previewImg('/img/discuss/2.ad222e0.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/3.0defd9c.jpg" @click="previewImg('/img/discuss/3.0defd9c.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/4.8c3f8e9.jpg" @click="previewImg('/img/discuss/4.8c3f8e9.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/5.dc724e2.jpg" @click="previewImg('/img/discuss/5.dc724e2.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/6.d0ba30b.jpg" @click="previewImg('/img/discuss/6.d0ba30b.jpg')" alt="" class="zoomable">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="discuss-content-size">
                        <div class="discuss-content"><img src="/img/discuss/1.a30c8df.png" alt="" class="a1"> <img
                                src="/img/discuss/2.4424ce6.png" alt="" class="a2">
                            <img src="/img/discuss/3.11209dc.png" alt="" class="a3">
                            <div class="discuss-title">
                                <p style="background: linear-gradient(45deg, rgb(172, 98, 204), rgb(172, 98, 204));">
                                    来自bY171SC1h3的分享</p>
                            </div>
                            <div class="discuss-imgshowfx">
                                <div class="discuss-imgshow"><img src="/img/discuss/1.5cc2353.jpg" @click="previewImg('/img/discuss/1.5cc2353.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/2.45356a9.jpg" @click="previewImg('/img/discuss/2.45356a9.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/3.95a3c04.jpg" @click="previewImg('/img/discuss/3.95a3c04.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/4.e3ada50.jpg" @click="previewImg('/img/discuss/4.e3ada50.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/5.36164e8.jpg" @click="previewImg('/img/discuss/5.36164e8.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/6.8b095da.jpg" @click="previewImg('/img/discuss/6.8b095da.jpg')" alt="" class="zoomable">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="discuss-content-size">
                        <div class="discuss-content"><img src="/img/discuss/1.a30c8df.png" alt="" class="a1"> <img
                                src="/img/discuss/2.4424ce6.png" alt="" class="a2">
                            <img src="/img/discuss/3.11209dc.png" alt="" class="a3">
                            <div class="discuss-title">
                                <p style="background: linear-gradient(45deg, rgb(172, 98, 204), rgb(172, 98, 204));">
                                    来自uaNjkt2A7k的分享</p>
                            </div>
                            <div class="discuss-imgshowfx">
                                <div class="discuss-imgshow"><img src="/img/discuss/1.443cf70.jpg" @click="previewImg('/img/discuss/1.443cf70.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/2.abc75c8.jpg" @click="previewImg('/img/discuss/2.abc75c8.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/3.ca1fb0b.jpg" @click="previewImg('/img/discuss/3.ca1fb0b.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/4.d776b1d.jpg" @click="previewImg('/img/discuss/4.d776b1d.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/5.ce77e90.jpg" @click="previewImg('/img/discuss/5.ce77e90.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/6.9e9fe05.jpg" @click="previewImg('/img/discuss/6.9e9fe05.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/7.7965477.jpg" @click="previewImg('/img/discuss/7.7965477.jpg')" alt="" class="zoomable">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="discuss-content-size">
                        <div class="discuss-content"><img src="/img/discuss/1.a30c8df.png" alt="" class="a1"> <img
                                src="/img/discuss/2.4424ce6.png" alt="" class="a2">
                            <img src="/img/discuss/3.11209dc.png" alt="" class="a3">
                            <div class="discuss-title">
                                <p style="background: linear-gradient(45deg, rgb(172, 98, 204), rgb(172, 98, 204));">
                                    来自W3Rqe53Bea的分享</p>
                            </div>
                            <div class="discuss-imgshowfx">
                                <div class="discuss-imgshow"><img src="/img/discuss/1.2d01c12.jpg" @click="previewImg('/img/discuss/1.2d01c12.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/2.6ab0dc2.jpg" @click="previewImg('/img/discuss/2.6ab0dc2.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/3.8a0d7b0.jpg" @click="previewImg('/img/discuss/3.8a0d7b0.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/4.0b2cc5d.jpg" @click="previewImg('/img/discuss/4.0b2cc5d.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/5.6ab0dc2.jpg" @click="previewImg('/img/discuss/5.6ab0dc2.jpg')" alt="" class="zoomable">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="discuss-content-size">
                        <div class="discuss-content"><img src="/img/discuss/1.a30c8df.png" alt="" class="a1"> <img
                                src="/img/discuss/2.4424ce6.png" alt="" class="a2">
                            <img src="/img/discuss/3.11209dc.png" alt="" class="a3">
                            <div class="discuss-title">
                                <p style="background: linear-gradient(45deg, rgb(172, 98, 204), rgb(172, 98, 204));">
                                    来自YvyF1C33nG的分享</p>
                            </div>
                            <div class="discuss-imgshowfx">
                                <div class="discuss-imgshow"><img src="/img/discuss/1.fc2743a.jpg" @click="previewImg('/img/discuss/1.fc2743a.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/2.b1a6c3c.jpg" @click="previewImg('/img/discuss/2.b1a6c3c.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/3.cb074b8.jpg" @click="previewImg('/img/discuss/3.cb074b8.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/4.0700f2c.jpg" @click="previewImg('/img/discuss/4.0700f2c.jpg')" alt="" class="zoomable">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="discuss-content-size">
                        <div class="discuss-content"><img src="/img/discuss/1.a30c8df.png" alt="" class="a1"> <img
                                src="/img/discuss/2.4424ce6.png" alt="" class="a2">
                            <img src="/img/discuss/3.11209dc.png" alt="" class="a3">
                            <div class="discuss-title">
                                <p style="background: linear-gradient(45deg, rgb(172, 98, 204), rgb(172, 98, 204));">
                                    来自EUbfDNbP4E的分享</p>
                            </div>
                            <div class="discuss-imgshowfx">
                                <div class="discuss-imgshow"><img src="/img/discuss/1.ebee42d.jpg" @click="previewImg('/img/discuss/1.ebee42d.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/2.6f9ca0e.jpg" @click="previewImg('/img/discuss/2.6f9ca0e.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/3.bb3796d.jpg" @click="previewImg('/img/discuss/3.bb3796d.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/4.e57fd7c.jpg" @click="previewImg('/img/discuss/4.e57fd7c.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/5.ecba136.jpg" @click="previewImg('/img/discuss/5.ecba136.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/6.5ab940e.jpg" @click="previewImg('/img/discuss/6.5ab940e.jpg')" alt="" class="zoomable">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="discuss-content-size">
                        <div class="discuss-content"><img src="/img/discuss/1.a30c8df.png" alt="" class="a1"> <img
                                src="/img/discuss/2.4424ce6.png" alt="" class="a2">
                            <img src="/img/discuss/3.11209dc.png" alt="" class="a3">
                            <div class="discuss-title">
                                <p style="background: linear-gradient(45deg, rgb(172, 98, 204), rgb(172, 98, 204));">
                                    来自3W6m4Kgvwu的分享</p>
                            </div>
                            <div class="discuss-imgshowfx">
                                <div class="discuss-imgshow"><img src="/img/discuss/1.60079cb.jpg" @click="previewImg('/img/discuss/1.60079cb.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/2.aaaa1bc.jpg" @click="previewImg('/img/discuss/2.aaaa1bc.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/3.e34bcde.jpg" @click="previewImg('/img/discuss/3.e34bcde.jpg')" alt="" class="zoomable">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="discuss-content-size">
                        <div class="discuss-content"><img src="/img/discuss/1.a30c8df.png" alt="" class="a1"> <img
                                src="/img/discuss/2.4424ce6.png" alt="" class="a2">
                            <img src="/img/discuss/3.11209dc.png" alt="" class="a3">
                            <div class="discuss-title">
                                <p style="background: linear-gradient(45deg, rgb(172, 98, 204), rgb(172, 98, 204));">
                                    来自vkjS6BuCBS的分享</p>
                            </div>
                            <div class="discuss-imgshowfx">
                                <div class="discuss-imgshow"><img src="/img/discuss/1.34ec3a4.jpg" @click="previewImg('/img/discuss/1.34ec3a4.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/2.590d30f.jpg" @click="previewImg('/img/discuss/2.590d30f.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/3.0d96239.jpg" @click="previewImg('/img/discuss/3.0d96239.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/4.778f5ac.jpg" @click="previewImg('/img/discuss/4.778f5ac.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/5.3810cc2.jpg" @click="previewImg('/img/discuss/5.3810cc2.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/6.a84f0ca.jpg" @click="previewImg('/img/discuss/6.a84f0ca.jpg')" alt="" class="zoomable">
                                </div>
                                <div class="discuss-imgshow"><img src="/img/discuss/7.9496804.jpg" @click="previewImg('/img/discuss/7.9496804.jpg')" alt="" class="zoomable">
                                </div>
                            </div>
                        </div>
                    </div>
                </div> <!---->
            </div>
        </div>
    </div>
</template>

<script>
import { ImagePreview } from 'vant';
export default {
    data() {
        return {

        };
    },
    methods: {
        back() {
            return window.history.back();
        },
        previewImg(src){
            ImagePreview([src])
        },
    },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";


.weui-tab__panel {
    box-sizing: border-box;
    height: 100%;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    padding-top: 100px;
    padding-bottom: 100px;
}

.discuss-bg {
    .discuss-content-size {
        padding-bottom: 40px;

        .discuss-content {
            margin: 0 auto;
            width: 90%;
            padding-top: 16px;
            border-radius: 50px;
            background: -webkit-linear-gradient(left, #E1EAFC, #DFE5FA);
            background: linear-gradient(to right, #E1EAFC, #DFE5FA);
            position: relative;

            .a1 {
                width: 70px;
                height: 70px;
                position: absolute;
                right: 0;
            }

            .a2 {
                position: absolute;
                width: 70px;
                height: 70px;
                bottom: 0;
            }

            .a3 {
                position: absolute;
                width: 70px;
                height: 70px;
                right: 0;
                bottom: 0;
            }

            .discuss-title {
                margin: 0 auto;
                width: 55%;

                p {
                    border-radius: 100px;
                    padding: 10px 40px;
                    background: #AC62CC;
                    color: #fff;
                    font-size: 24px;
                    text-align: center;
                }
            }

            .discuss-imgshowfx {
                width: 85%;
                margin: 0 auto;
                display: -webkit-box;
                display: -webkit-flex;
                display: flex;
                -webkit-flex-wrap: wrap;
                flex-wrap: wrap;
                -webkit-box-pack: justify;
                -webkit-justify-content: space-between;
                justify-content: space-between;

                .discuss-imgshow {
                    padding: 10px 0;
                    width: 30%;
                    height: auto;
                    display: block;

                    img {
                        width: 100%;
                        height: auto;
                        cursor: pointer;
                        -webkit-transition: -webkit-transform 0.3s ease-in-out;
                        transition: -webkit-transform 0.3s ease-in-out;
                        transition: transform 0.3s ease-in-out;
                        transition: transform 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out;
                    }
                }
            }
        }
    }
}
</style>
